import { environment } from "src/environments/environment";

const base_url = environment.base_url;
// const testBase = environment.testBase;

export const apiEnpoints = {

    ///User management
    addSystemUser:`${base_url}/api/SystmeUser/add/user`,
    getAllSystemUsers:`${base_url}/all/user`,
    logout:`${base_url}/api/Authentication/revoke/user/token`,
    getAllMechandisers:`${base_url}/all/merchandiser/users`,
    getAssignToUsers:`${base_url}/api/SystmeUser/user/list/assigned-to`,
    getAssignessList:`${base_url}/api/SystmeUser/user/list/assignees`,
    saveAssigneeUsers:`${base_url}/api/SystmeUser/save/user/assignees`,

    ///Buyer management
    getAllBuyer:`${base_url}/all/buyer`,
    addBuyer: `${base_url}/api/Buyer/add/buyer`,
    getbyersuserid: `${base_url}/api/Buyer/all/buyers/userid`,
    getPatternDataByBuyerId: `${base_url}/api/OPSPattern/all/pattern/buyerid`,

    //shipment
    getBuyerById: `${base_url}/api/Buyer/all/buyer/specificid`,
    submitShipmentdetails: `${base_url}/api/Shipemnt/add/shipment`,
    getShipment: `${base_url}/api/Shipemnt/all/shipment/specificid`,

    //local Agent
    submitAgent: `${base_url}/api/LocalAgent/add/agent`,
    getlocalagentinByerid: `${base_url}/api/LocalAgent/all/localagent/buyerid`,

    //material
    getMaterial: `${base_url}/api/pattern/allMaterial/patternId`,

    //emblishment
    getEmblishment: `${base_url}/api/OPSPattern/allemblishment/patternId`,
   
    //vl
    getSelectedTmpvl: `${base_url}/api/pattern/all/Vl/patternId`,
    getVLEmblishment: `${base_url}/api/OPSPattern/allvlemblishment/vlId`,
    submitVlDetails:`${base_url}/api/pattern/add/desing/tmp`,
    getInitialData: `${base_url}/api/OPSPattern/vl/init/data`,
    getVlById: `${base_url}/edit/vl/details`,
    getCostMaterials:`${base_url}/api/pattern/get/additional/cost/materials`,
    saveCategory:`${base_url}/api/pattern/save/vl/etc/category`,
    getVlByByerId: `${base_url}/api/pattern/all/Vl/Buyer/buyerId`,
    cloneVL: `${base_url}/api/OPSPattern/vl/clone/specific/vl`,


    //size
    getAllSize: `${base_url}/all/size`,
    submitSizeDetails: `${base_url}/api/pattern/add/sizedetails`,
    submitSize: `${base_url}/api/pattern/add/size`,
     
    //podetails
    getpoforvlid: `${base_url}/api/po/po/vlId`,
    getInitPoDetails: `${base_url}/api/po/init/data`,


    //pattern
    getAllSpecialDetail: `${base_url}/all/SpecialDetail`,
    getFabricData:`${base_url}/all/Materials/fabric`,
    getMaterialData:`${base_url}/all/accessories`,
    getSizeDataById:`${base_url}/api/OPSPattern/sizes/for/sizeset`,
    getAllSublimations: `${base_url}/all/sublimations`,
    getPatterninByerid: `${base_url}/api/OPSPattern/all/pattern/buyerid`,
    getPatternById: `${base_url}/api/OPSPattern/edit/selected/pattern/data`,
    getAllPositions: `${base_url}/api/ScreenPrint/get/all/print/part`,
    addNewPosition: `${base_url}/api/ScreenPrint/save/new/print/part`,
    getPositionByType: `${base_url}/api/ScreenPrint/get/print/part/names`,
    getQtyRanges: `${base_url}/api/OPSPattern/get/qty/ranges`,
    addQtyRangesAmount: `${base_url}/api/OPSPattern/save/pattern/ranges`,
    clonePattern: `${base_url}/api/OPSPattern/clone/specific/pattern`,
    deletePatternImage:`${base_url}/api/OPSPattern/delete/pattern/image`,
    getCostDataByPatternId: `${base_url}/api/OPSPattern/get/pattern/cost/descriptions`,
    
    //sales order
    getBasicDataForSalesOrder: `${base_url}/api/ScreenPrint/get/screen-print/basic/details`,
    submitSalesOrder: `${base_url}/api/ScreenPrint/add/screen-print/sales/order`,
    getSalesOrderBySearch: `${base_url}/api/ScreenPrint/get/screen-print/sales/order/number`,
    getAllSalesOrders:`${base_url}/api/ScreenPrint/get/screen-print/sales/order/details`,

    //Gate Pass
    getBasicDataForGatePass:`${base_url}/api/ScreenPrint/get/screen-print/bundles/basic/details`,
    submitGatePassOrder: `${base_url}/api/ScreenPrint/add/screen-print/sales/order/bundles`,
    getGetPassBySearch: `${base_url}/api/ScreenPrint/get/screen-print/gatepass/numberr`,
    getAllGatePasses:`${base_url}/api/ScreenPrint/get/screen-print/sales/order/bundle/details`,
    getBarcodeData:`${base_url}/api/ScreenPrint/get/selected/bundle/transaction/details`,

    //Barcode reader
    getAllDepartment:`${base_url}/api/ScreenPrint/get/bundle/departments`,
    addNewDepartment:`${base_url}/api/ScreenPrint/save/bundle/department`,
    getDepartmentById:`${base_url}/api/ScreenPrint/get/selected/bundle/department`,
    validateEmployeeId:`${base_url}/api/ScreenPrint/validate/employee/id`,
    getBarcodeStatus:`${base_url}/api/ScreenPrint/check/bundle/transaction/details`,
    submitInput:`${base_url}/api/ScreenPrint/save/bundle/transaction/input`,
    submitOutput:`${base_url}/api/ScreenPrint/save/bundle/transaction/output`,

    //PO V2
    getPOV2InitData: `${base_url}/api/po/init/data/v2`,
    getPOV2InitDataPopUp: `${base_url}/api/po/popup/init/data`,
    savePoDetails:`${base_url}/api/po/save/po/details`,
    getAllPurchaseOrder:`${base_url}/all/purchasingorder`,
    getAllMasterPurchaseOrder:`${base_url}/all/master-po-details`,
    getAmountDataByVl:`${base_url}/api/pattern/get/po/vl/price/data`,
    getPoById:`${base_url}/all/po/master`,
    getQuatationData:`${base_url}/api/po/quotation`,
    getInvoiceData:`${base_url}/api/po/invoice`,
    addRemarkMasterPo:`${base_url}/api/po/po/master/remark`,
    addRemarkSubPo:`${base_url}/api/po/po/remark`,
    changeApprovalStatus:`${base_url}/api/po/po/approval/status`,
    onEditDeliveryData:`${base_url}/api/po/update/adm/m-po`,
    deleteVlImage:`${base_url}/api/OPSPattern/delete/vl/image`,
    deleteVl:`${base_url}/api/OPSPattern/delete/vl`,
    viewReportData:`${base_url}/api/po/view/report`,
    disablePo:`${base_url}/api/po/purchasing/order/disable`,
    enablePo:`${base_url}/api/po/purchasing/order/enable`,
    deletePo:`${base_url}/api/po/purchasing/order/delete`,

    //Change sales order
    getSalesOrderBundles:`${base_url}/api/ScreenPrint/get/sales-order/bundles`,
    saveBundleStatus:`${base_url}/api/ScreenPrint/save/bundle/status`,

    getDispatchGatePassesById :`${base_url}/api/ScreenPrint/dispatch/gatepass`,
    getDispatchInvoiceById:`${base_url}/api/ScreenPrint/dispatch/invoice`,

    getDispatchGatePasses:`${base_url}/api/ScreenPrint/get/dispatched/gatepasses`,
    getDispatchInvoices:`${base_url}/api/ScreenPrint/get/dispatched/invoices`,

    getSelectedGatePass:`${base_url}/api/ScreenPrint/get/selected/bundles/gatepass`,
    getSelectedInvoice:`${base_url}/api/ScreenPrint/get/selected/bundle/invoice`,

    getPrintPartListBySalesOrder: `${base_url}/api/ScreenPrint/get/print/part/for/order`,
    addSpecialDetails:`${base_url}/api/pattern/save/vl/special/instructions`,

    ////////////////////////
    // getCat: `${testBase}/get/category`,
    addClientName: `${base_url}/api/pattern/save/vl/po/jobname`,
    getAllClientNames: `${base_url}/api/pattern/view/vl/po/jobname`,
    deleteClientName: `${base_url}/api/pattern/delete/job/name`,


    enableUser:`${base_url}/api/SystmeUser/activate/user`,
    disableUser:`${base_url}/api/SystmeUser/deactivate/user`,
}

